import { render, staticRenderFns } from "./DfNavbar.vue?vue&type=template&id=67c95c1e&scoped=true&"
import script from "./DfNavbar.vue?vue&type=script&lang=js&"
export * from "./DfNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DfNavbar.vue?vue&type=style&index=0&id=67c95c1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c95c1e",
  null
  
)

export default component.exports